// extracted by mini-css-extract-plugin
var _1 = "Terms-module__content___pp0ht";
var _2 = "Terms-module__liStrong___IUAf3";
var _3 = "Terms-module__ol___ThIiw";
var _4 = "Terms-module__ol2___t3OPW";
export { _1 as "content", _2 as "liStrong", _3 as "ol", _4 as "ol2" }
